import type { StrictTypedTypePolicies } from "../../gql/graphql";


// These Query.fields policies inform Apollo that the query returns the resource
// with the specified `__typename` & `id`. This allows those queries to be
// served directly from the cache if all the required data is present.
//
// TODO(#560): Generate this policy for all by-id queries.
export const TYPE_POLICIES: StrictTypedTypePolicies = {
	Query: {
		fields: {
			companyLocation: (_, { args, toReference }) => toReference({
				__typename: "CompanyLocation",
				id: args?.["id"],
			}),
			userProfile: (_, { args, toReference }) => toReference({
				__typename: "UserProfile",
				id: args?.["id"],
			}),
			rysSubscription: (_, { args, toReference }) => toReference({
				__typename: "RysSubscription",
				id: args?.["id"],
			}),
			signUpRequest: (_, { args, toReference }) => toReference({
				__typename: "SignUpRequest",
				id: args?.["id"],
			}),
		},
	},
};
